const AGROOTURI = "https://api.agstark.com/";
const localStoragePostcode = "agSitePostcode";
const localStorageSuburb = "agSitePostSuburb";
const localStorageState = "agSitePostState";
const localStorageStateId = "agSitePostStateId";

const postcodeGetterIdText = "postcodeGetter";
const postcodeGetterBottomIdtext = "postcodeGetterBottom";

const shippingDetailsDivIdNameShippingFile = "shippingDetails";

const suburbPageSize = "20";

const postcodeSelectorHeader = document.getElementById(postcodeGetterIdText);
const postcodeGetterBottom = document.getElementById(postcodeGetterBottomIdtext);
const shippingDetailsDivIdNameShippingFileElement = document.getElementById(shippingDetailsDivIdNameShippingFile);

// console.log("LOADING PAGE", localStorage.getItem(localStoragePostcode),  localStorage.getItem(localStorageSuburb));


//Create the text string ie . suburbname, 2165. Returns empty string if either local storage element is false or null
const theTextSet = setDefaultTextboxText(localStorage.getItem(localStoragePostcode), localStorage.getItem(localStorageSuburb));
setShippingTextboxValues(postcodeSelectorHeader, postcodeGetterBottom, theTextSet);



/**
*  * Sets the text of the delivering to location with the data from internal storage
* Date is: postcode, suburb name
* 
* @param str deliveringToId - ID of the delivering to element 
*/
function setDeliveringToLocation(){
    // const deliveringTo = document.getElementById(deliveringToId);
    // deliveringTo.innerText = `${localStorage.getItem("agSitePostSuburb")}, `;

    // const postcodeGetterBottom = document.getElementById(postcodeGetterBottomIdtext);
    // postcodeGetterBottom.innerText = `${localStorage.getItem("agSitePostcode")}`;
    
}



function showSuburbList(suburbList, postcodeData, wrapper, textInput, textInputb){
    // console.log("Showing suburbs", suburbList, postcodeData);

    try{
        if(postcodeData.length === 0){
            return;
        }

        suburbList.innerHTML = "";
        suburbList.style.display = "block";
        suburbList.style.boxShadow = "3px 3px 4px 2px rgba(0, 0, 0, 0.15)"; // Adding drop shadow dynamically
        suburbList.style.fontWeight = "400";


        postcodeData.forEach((value)=>{
            
            const newDiv = document.createElement('div');

            newDiv.classList.add("hoverText");
            newDiv.classList.add("suburbDownloadName");
            newDiv.style.textTransform = 'capitalize';
            

            newDiv.textContent = `${value.attributes.suburb_name},
                                ${value.attributes?.state?.data?.attributes?.state_code},
                                ${value.attributes.postcode}
                                `;
            
            suburbList.appendChild(newDiv);

            //Do this when a new suburb is clicked
            newDiv.addEventListener("click", (e)=>{
                // console.log("CLICKED SUBURB");

                //Add the data to local storage
                
                setLocalStorage(value.attributes.postcode, 
                                value.attributes.suburb_name, 
                                value.attributes?.state?.data?.attributes?.state_code,
                                value.id);
                
                
                //display suburb name and postcode in the input box
                const textboxText = setDefaultTextboxText(value.attributes.postcode, value.attributes.suburb_name);
                setShippingTextboxValues(textInput, textInputb, textboxText);

                suburbList.style.display = 'none';

                adjustWidth(postcodeSelectorHeader);

                //Show snackbar
                // console.log("Postcode changed...");

                //Reset search info elements
                
                // Create and append 3 div elements with class inventoryNote - REMOVE AFTER TESTING
                // for(let i = 0; i < 3; i++){
                //     console.log("Creating inventory note div");
                //     const inventoryNoteDiv = document.createElement('div');
                //     inventoryNoteDiv.classList.add('inventoryNote');
                //     document.body.appendChild(inventoryNoteDiv);
                // } // Create and append 3 div elements with class inventoryNote - REMOVE AFTER TESTING

                
                //get all fields that contain the product productInfoHoverElement
                const inventoryNotes = document.getElementsByClassName("inventoryNote");

                // console.log("Inventory notes: " + inventoryNotes);


                //Go through all boost ai elements and set the search info 
                for(let i = 0; i < inventoryNotes.length; i++){
                    setSearchInfo(inventoryNotes[i]);
                }


                //----------------------------------

            });
        });
        //When the user clicks out, then set the display values
        document.addEventListener('click', function(event) {
            //Set values of textboxes when the user clicks out
            // if(event.target.id != postcodeGetterBottomIdtext && event.target.id != postcodeGetterIdText){ 
            //     const textboxText = setDefaultTextboxText(localStorage.getItem(localStoragePostcode), localStorage.getItem(localStorageSuburb));
            //     setShippingTextboxValues(textInput, textInputb, textboxText);
            // }

            // Check if the click is inside the suburbList or wrapper
            if (!suburbList.contains(event.target) && !wrapper.contains(event.target)) {
                // Clicked outside both suburbList and wrapper, hide suburbList
                suburbList.style.display = 'none';
            }
        });
    } catch(err){
        console.log("Click Error");
    }
}

/**
* Get all shipping time, shipping price, shipping type, product type, text, and location data
* for this particular suburb
* 
* @param int suburbId - Database primary key id of the suburb 
* @returns {*} with data from strapi
*/
async function loadShippingTimesUpper(suburbId, shopifyProductId, stock, stockBuffer, productType, stockArrivalDate = ""){
    
    
    // console.log("LOADING UPPER");
    
    // console.log("Calling loadShipping");
    // const res = await fetch(`https://api.agstark.com/api/ship-time-price/get-calculated-by-product?suburbId=${suburbId}&shopifyProductId=${shopifyProductId}&stock=${stock}&stockBuffer=${stockBuffer}&productType=${productType}&stockArrivalDate=${stockArrivalDate}`);
  
    // const data = await res.json();
  
    //New fetch function which changes base domain based on env status
    // const data = await AG.fetch(`/api/ship-time-price/get-calculated-by-product?suburbId=${suburbId}&shopifyProductId=${shopifyProductId}&stock=${stock}&stockBuffer=${stockBuffer}&productType=${productType}&stockArrivalDate=${stockArrivalDate}`, {
    //     method: 'GET',
    // });
    
    // return data.data;

    let counter = 0;
    const waitLimit = 1000;

    while(sessionStorage.getItem("timesRetrieved") === "false"){
        // console.log("Waiting for shipping slots to be retrieved");
        await new Promise(resolve => setTimeout(resolve, 100));
        counter++;
        if(counter > waitLimit){
            break;
        }
    }

    const slotsPass = sessionStorage.getItem("shippingSlots");


    //New fetch function which changes base domain based on env status
    const data = await AG.fetch(`/api/ship-time-price/get-calculated-by-product?suburbId=${suburbId}&shopifyProductId=${shopifyProductId}&stock=${stock}&stockBuffer=${stockBuffer}&productType=${productType}&stockArrivalDate=${stockArrivalDate}&planningDatesA=${slotsPass}`, {
        method: 'GET',
    });

    return data.data;
}

/**
 * This is for when we show the info on search page / collection page
 * @param {*} productItem 
 * @returns 
 */
async function setSearchInfo(productItem){
    const productId = productItem.getAttribute('data-product-id');
    // console.log("productId", productItem)
    if(!productId){
        return;
    }
    
    //CUSTOM COM GUYS
    let storedSuburbIdMain = localStorage.getItem("agSitePostStateId");
    storedSuburbIdMain = storedSuburbIdMain ? storedSuburbIdMain : null;


    const noDelivery = storedSuburbIdMain ? `Unfortunately we are unable to deliver this item to your region yet. Please select a different delivery postcode or contact us on 1300 444 268 or via live chat to discuss further.` : `Please enter your postcode to view the available delivery dates for your region.`;

    
    const osSpan =  document.querySelector(`#outofstock${productId}`);//if not null then we do an api call
    const inStockSpan =  document.querySelector(`#instock${productId}`);//if not null then we do an api call
    const lowStockSpan =  document.querySelector(`#lowstock${productId}`);//if not null then we do an api call

    const stockBuffer =  document.querySelector(`#stockBuffer${productId}`);
    const stockBufferValue = stockBuffer.innerText ? parseInt(stockBuffer.innerText) : 0;

    const stockLevel =  document.querySelector(`#stockLevel${productId}`);
    const stockLevelValue = stockLevel.innerText ? parseInt(stockLevel.innerText) : 0;


    const productType = document.querySelector(`#productType${productId}`).innerText;

    
    const mainProductSpan = document.querySelector(`#mainProductSpan${productId}`);

    

    //Only call the api if WE HAVE A SUBURB AND A PRODUCT TYPE SET
    if(storedSuburbIdMain && productType){


        //Get ship time data from the api
        const shipTimes = loadShippingTimesUpper(storedSuburbIdMain, productId, stockLevelValue, stockBufferValue, productType);

        shipTimes.then((shipTimeRes) => {
            
            //OUT OF STOCK
            if(osSpan){
                // console.log("OS",shipTimeRes[0].dateStartText )
                //Updating the shipping date on the frontend
                if(shipTimeRes[0]?.dateStartText){
                    mainProductSpan.innerHTML = `This one flew off the shelves, but you haven't missed out, it's coming back!  You will be able to select a delivery date at checkout. We will notify you if there are any delays. The current ETA for delivery is ${shipTimeRes[0].dateStartText}.`;
                } else {
                    mainProductSpan.innerHTML = noDelivery;
                }
            }

            //IN STOCK
            if(inStockSpan){
                // console.log("inStockSpan",shipTimeRes[0].dateStartText )
                //Updating the shipping date on the frontend
                if(shipTimeRes[0]?.dateStartText){
                    mainProductSpan.innerHTML = `Delivery ${shipTimeRes[0].by_or_between} ${shipTimeRes[0].opinionatedDateText}.`;
                } else {
                    mainProductSpan.innerHTML = noDelivery;
                } 
            }

            //LOW STOCK
            if(lowStockSpan){
                // console.log("lowStockSpan",shipTimeRes[0].opinionatedDateText )
                //Updating the shipping date on the frontend
                if(shipTimeRes[0]?.dateStartText){
                    mainProductSpan.innerHTML = `Less than 2 remaining in stock. Be quick! Delivery ${shipTimeRes[0].by_or_between} ${shipTimeRes[0].opinionatedDateText}.`;
                } else {
                    mainProductSpan.innerHTML = noDelivery;
                } 
            }

        }).catch((res_error) => {
            console.log("Error!", res_error);
            mainProductSpan.innerHTML = noDelivery;
        });
    } else {
        mainProductSpan.innerHTML = noDelivery;
    }
}

/**
 * Gets the postcode data from the api via getPostcode
 * Clears the autofill dropdown
 * Adds new postcode data from the api to the dropdown
 */
async function setPostcodeDiv(suburbList, postcodeGetter, wrapper, secondPostcodeGetter){
    // console.log("RUNNING SET POSTCODE");
    let postcodeData = [];
    
    //Only run if the field is not null, the field has 4 chars, and the chars are numbers
    if(!isNaN(postcodeGetter.value) && postcodeGetter.value.trim().length === 4 && !/[^0-9]/.test(postcodeGetter.value.trim())){
        //Getting data using postcode
        postcodeData = await getPostcode(postcodeGetter.value.trim());
        
        showSuburbList(suburbList, postcodeData, wrapper, postcodeGetter, secondPostcodeGetter);

    //Only run if the field is not null, the field has 3 or more chars, and the chars are alpha numeric
    } else if (postcodeGetter.value.trim().length >= 3 && !/[^a-zA-Z ]/.test(postcodeGetter.value.trim())){
        //Getting data using suburb name 3 chars or more
        postcodeData = await getSuburbs(postcodeGetter.value.trim());

        showSuburbList(suburbList, postcodeData, wrapper, postcodeGetter, secondPostcodeGetter);

    }
    
    else {
        suburbList.innerHTML = "";
        suburbList.style.display = "none";
    }

        
    

}

/**
 * Get postcode data from the api
 * Will provide suburbs and postcodes
 * @param str postcode - postcode should be 4 chars
 * @returns array of objects
 */
async function getPostcode(postcode) {
    // console.log("Getting postcode data");

    //Old function to call using single API endpoint domain
    // const res = await fetch(`${AGROOTURI}api/suburbs?sort[0]=suburb_name:asc&fields[0]=suburb_name&fields[1]=postcode&filters[postcode][$contains]=${postcode}&populate=*&pagination[pageSize]=${suburbPageSize}`);

    // const data = await res.json();


    //New function to call depending on Staging or Prod
    const data = await AG.fetch(`/api/suburbs?sort[0]=suburb_name:asc&fields[0]=suburb_name&fields[1]=postcode&filters[postcode][$contains]=${postcode}&populate=*&pagination[pageSize]=${suburbPageSize}`, {
        method: 'GET',
    });

    // console.log("getPostcode data", data?.data);
    return data?.data;
}

/**
 * Gets suburb data from the api
 * @param str suburb - string with suburb name - three or more chars
 * @returns {*} - array of objects
 */
async function getSuburbs(suburb){
    // console.log("Getting suburb data");

    //Old function to call using single API endpoint domain
    // const res = await fetch(`${AGROOTURI}api/suburbs?sort[0]=suburb_name:asc&fields[0]=suburb_name&fields[1]=postcode&filters[suburb_name][$contains]=${suburb}&populate=*&pagination[pageSize]=${suburbPageSize}`);
    // // const data = await res.json();

    //New function to call depending on Staging or Prod
    const data = await AG.fetch(`/api/suburbs?sort[0]=suburb_name:asc&fields[0]=suburb_name&fields[1]=postcode&filters[suburb_name][$contains]=${suburb}&populate=*&pagination[pageSize]=${suburbPageSize}`, {
        method: 'GET',
    });

    // console.log("getSuburbsgetSuburbsgetSuburbsgetSuburbsgetSuburbs data", data);

    return data?.data;
}



function setElementListeners(wrapperDiv, iconElement, suburbListSet, postcodeSelectorMain, postcodeSelectorSecondary, setPostcodeDivFunction, showHidePenFunction, showHidePen, penToHide){
    // console.log("Calling new function ", iconElement);
    //When I focus on the header  postcode getter , select the whole thing
    postcodeSelectorMain.addEventListener(`focus`, () => postcodeSelectorMain.select());

    //When I type into the header  postcode getter , do this
    postcodeSelectorMain.addEventListener('input', function () {
        postcodeSelectorMain.value = postcodeSelectorMain.value.replace(/[^a-zA-Z0-9, ]/g, '').replace(/\s\s+/g, ' ');

        if(postcodeSelectorSecondary){
            postcodeSelectorSecondary.value = postcodeSelectorMain.value;
        }
        
        setPostcodeDivFunction(suburbListSet, postcodeSelectorMain, wrapperDiv, postcodeSelectorSecondary);

        try{
            shippingDetailsDivIdNameShippingFileElement.innerHTML = "";
        } catch (err){
            // console.log(err);
        }
        if(showHidePen){
            showHidePenFunction(penToHide, postcodeSelectorMain);
        }
    });

    //When I click  the header  postcode getter , do this
    postcodeSelectorMain.addEventListener('click', function () {
        postcodeSelectorMain.value = postcodeSelectorMain.value.replace(/[^a-zA-Z0-9, ]/g, '').replace(/\s\s+/g, ' ');
        postcodeSelectorMain.select();
        
        if(postcodeSelectorSecondary){
            postcodeSelectorSecondary.value = postcodeSelectorMain.value;
        }

        setPostcodeDivFunction(suburbListSet, postcodeSelectorMain, wrapperDiv, postcodeSelectorSecondary);

        if(showHidePen){
            showHidePenFunction(penToHide, postcodeSelectorMain);
        }
    });

    //When I click  the header  postcode getter CHEVRON icon , do this
    iconElement.addEventListener('click', function () {
        postcodeSelectorMain.focus();
        postcodeSelectorMain.value = postcodeSelectorMain.value.replace(/[^a-zA-Z0-9, ]/g, '').replace(/\s\s+/g, ' ');
        postcodeSelectorMain.select();
        
        if(postcodeSelectorSecondary){
            postcodeSelectorSecondary.value = postcodeSelectorMain.value;
        }
        
        setPostcodeDivFunction(suburbListSet, postcodeSelectorMain, wrapperDiv, postcodeSelectorSecondary);

        if(showHidePen){
            showHidePenFunction(penToHide, postcodeSelectorMain);
        }
    });
}


/**
 * 
 * THE FOLLOWING FUNCTIONS POPULATE AND MODIFY THE INPUT FIELDS. FIRST IS HEADER INPUT FIELD. SECOND, IF APPLICABLE, IS THE INPUT FIELD AT THE BOTTOM ON THE PRODUCT PAGE
 * 
 */
//Header postcode selector functions ---------------------------------------------------------------------------------------------------------------------------------
    const postcodeSelectorWrapper = document.getElementById("postcodeWrapperTop");
    const postcodeSelectorChevron = document.getElementById("postcodeSelectorChevron");
    const suburbList = document.getElementById("suburbList"); 

    //Upper
    setElementListeners(postcodeSelectorWrapper, postcodeSelectorChevron, suburbList, postcodeSelectorHeader, postcodeGetterBottom, setPostcodeDiv, showHidePen, true, postcodeSelectorChevron);

    //Bottom does not always appear, so conditional to save resources if not there
    if(postcodeGetterBottom){
        const postcodeWrapperBottom = document.getElementById("postcodeWrapperBottom");
        const postcodeSelectorPenBottom = document.getElementById("editSuburb");
        const suburbListBottom = document.getElementById("suburbListBottom");
        setElementListeners(postcodeWrapperBottom, postcodeSelectorPenBottom, suburbListBottom, postcodeGetterBottom, postcodeSelectorHeader, setPostcodeDiv, showHidePen, true, postcodeSelectorChevron);
    }

//---------------------------------------------

adjustWidth(postcodeSelectorHeader);

postcodeSelectorHeader.addEventListener('click', function() {
    // console.log("Click");
    adjustWidth(postcodeSelectorHeader);
});

postcodeSelectorHeader.addEventListener('input', function() {
    // console.log("input");
    adjustWidth(postcodeSelectorHeader);
});


//Hide chevron
showHidePen(postcodeSelectorChevron, postcodeSelectorHeader);


function adjustWidth(input) {
    if(!input.value){
        input.style.width = "193px";
        return;
    }

    // Create a temporary span to measure the width of the input content
    const tempSpan = document.createElement('span');
    tempSpan.style.visibility = 'hidden';
    tempSpan.style.position = 'absolute';
    tempSpan.style.whiteSpace = 'pre';
    tempSpan.style.fontSize = window.getComputedStyle(input).fontSize;
    tempSpan.style.fontFamily = window.getComputedStyle(input).fontFamily;
    tempSpan.textContent = input.value || input.placeholder; // Use placeholder text if input is empty
    document.body.appendChild(tempSpan);

    // Set the input's width to the span's width plus some padding
    input.style.width = tempSpan.offsetWidth + 20 + 'px'; // Adjust 10px for padding
    document.body.removeChild(tempSpan);
}



// function adjustWidth(inputField) {
    
//     if(!inputField.value){
//         inputField.style.width = "193px";
//         return;
//     }

//     const value = inputField.value;
//     let width = (value.length * 7) + 16; // 8px per character

//     if(width > 260){
//         width = 260;
//     }
    
//     inputField.style.width = `${width}px`;
// }


function showHidePen(penElement, elementToCheck){
    if(elementToCheck.value){
        penElement.style.display = "inline";
    } else if(!elementToCheck.value){
        penElement.style.display = "none";
    }
}

/**
 * Sets the local storage of three items - postcode, suburb, state
 * 
 * @param str postcode 
 * @param str suburb 
 * @param str state 
 */
function setLocalStorage(postcode, suburb, state, stateId){
    localStorage.setItem(localStoragePostcode,postcode);
    localStorage.setItem(localStorageSuburb,suburb);
    localStorage.setItem(localStorageState,state);
    localStorage.setItem(localStorageStateId,stateId);
}


/**
 * We want to set the input textbox values
 * Only assign if the boxes exist on the front page
 * 
 * @param obj boxa - inut box element
 * @param obj boxb - inut box element
 * @param str text - The texdt value to set the input box elements to
 */

function setShippingTextboxValues(boxa, boxb, text){
    
    if(boxa){
        boxa.value = text;
    }
    if(boxb){
        boxb.value = text;
    }
    
}

/**
 *  We want to set the postcode suburb text 
 *  Create the text string ie . suburbname, 2165. Returns empty string if either local storage element is false or null
 * 
 * @param str postcode - postcode string
 * @param str suburb - suburb string
*/

function setDefaultTextboxText(postcode, suburb){
    
    return !postcode || !suburb ? "" : `${suburb}, ${postcode}`;
}



